import { Grid, Typography } from '@material-ui/core';
import { MessageBox } from 'design-system';

const InformationSection = (): JSX.Element => {
  return (
    <Grid item xs={12} sm={8} md={12}>
      <MessageBox
        data-testid="information-message"
        flexAlign="flex-start"
        message={
          <Typography
            variant="caption"
            style={{ fontWeight: 500, fontSize: 13 }}
          >
            Recuerda que{' '}
            <strong>este seguro es sólo para vehículos de uso personal.</strong>{' '}
            No se cubren autos utilizados para traslado de carga o de pasajeros
            (taxi o similares). Conforme al Artículo 32 de la ley reguladora del
            Contrato de Seguros, toda declaración falsa o inexacta por parte del
            asegurado o su representante que pudieren influir en las condiciones
            del contrato, traen consigo la nulidad del mismo.
          </Typography>
        }
        variant="info"
        hideCloseButton
      />
    </Grid>
  );
};

export default InformationSection;
